// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
const name = "clipPlaneFragmentDeclaration";
const shader = `#ifdef CLIPPLANE
varying float fClipDistance;#endif
#ifdef CLIPPLANE2
varying float fClipDistance2;#endif
#ifdef CLIPPLANE3
varying float fClipDistance3;#endif
#ifdef CLIPPLANE4
varying float fClipDistance4;#endif
#ifdef CLIPPLANE5
varying float fClipDistance5;#endif
#ifdef CLIPPLANE6
varying float fClipDistance6;#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @internal */
export const clipPlaneFragmentDeclaration = { name, shader };
//# sourceMappingURL=clipPlaneFragmentDeclaration.js.map